import { twMerge } from 'tailwind-merge';
import { BLOBS, classes } from './utils';

export default function BackgroundBlobs() {
  return (
    <div aria-hidden className={classes.background}>
      {BLOBS.map(([blobClass, blobStyle], i) => (
        <div
          key={i}
          style={blobStyle}
          className={twMerge(classes.blob, blobClass)}
        />
      ))}
    </div>
  );
}
